import { TERM_SESSION } from '@/lib/terms';

export const SESSION_LABEL_LOWER = `${TERM_SESSION.toLowerCase()}s`;

export const formatNumber = (value: number) => new Intl.NumberFormat('en-US').format(value);

export const formatDecimal = (value: number, decimals = 1) =>
  new Intl.NumberFormat('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);

export const formatPercent = (value: number) =>
  new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
  }).format(value / 100);

export const formatTokens = (value: number) => {
  if (value >= 1_000_000_000) {
    return `${(value / 1_000_000_000).toFixed(1)}B`;
  }
  if (value >= 1_000_000) {
    return `${(value / 1_000_000).toFixed(1)}M`;
  }
  if (value >= 1_000) {
    return `${(value / 1_000).toFixed(1)}K`;
  }
  return value.toFixed(0);
};

export const defaultColors = [
  '#0ea5e9', // sky-500
  '#6366f1', // indigo-500
  '#f59e0b', // amber-500
  '#8b5cf6', // violet-500
  '#ec4899', // pink-500
  '#14b8a6', // teal-500
];

// Re-export the unified sizing snapshot from the new engine
export type { NewSizingSnapshot as UnifiedSizingSnapshot } from '@/sizing/newSizingEngine';
